import { inject, Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActiveToast, IndividualConfig, ToastrService } from 'ngx-toastr';

export type positionClass = 'top-left' | 'top-right' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center' | 'top-full-width' | 'bottom-full-width';
export type toastType = 'success' | 'info' | 'warning' | 'error';

@Injectable({
	providedIn: 'root'
})
export class NotifyService {
	//https://npm.io/package/ngx-toastr

	/**
	 * @url https://ngx-toastr.vercel.app/
	 */
	private _options: Partial<IndividualConfig> = {
		closeButton: true,
		timeOut: 7000,
		extendedTimeOut: 1000,
		//disableTimeOut: false,
		//easing: 'ease-in',
		easeTime: 200,
		enableHtml: true,
		progressBar: true,
		progressAnimation: 'increasing',
		//toastClass: 'ngx-toastr',
		positionClass: 'toast-top-right',
		//titleClass: 'toast-title',
		//messageClass: 'toast-message',
		tapToDismiss: false,
		onActivateTick: false
	};

    private readonly domSanitizer = inject(DomSanitizer);

	private readonly toastr = inject(ToastrService);

	/**
	 *
	 * @param message HTML string
	 * @param title string, don't support HTML
	 * @param timeOut time in milliseconds default 7000, 0 to keep
	 * @param positionClass position of notification default top-right
	 * @param shading deprecated
	 * @returns
	 */
	success = (message: string, title?: string, timeOut?: number, positionClass?: positionClass, shading?: boolean): ActiveToast<any> => {
		let options = {
			... this._options,
			timeOut : timeOut ?? this._options.timeOut,
			positionClass: 'toast-' + (positionClass ?? 'top-right')
		}
		return this.toastr.success(this.domSanitizer.sanitize(SecurityContext.HTML, message ?? '')!, title ?? undefined, options)
	}

	/**
	 *
	 * @param message HTML string
	 * @param title string, don't support HTML
	 * @param timeOut time in milliseconds default 7000, 0 to keep
	 * @param positionClass position of notification default top-right
	 * @param shading deprecated
	 * @returns
	 */
	info = (message: string, title?: string, timeOut?: number, positionClass?: positionClass, shading?: boolean): ActiveToast<any> => {
		let options = {
			... this._options,
			timeOut : timeOut ?? this._options.timeOut,
			positionClass: 'toast-' + (positionClass ?? 'top-right')
		}
		return this.toastr.info(this.domSanitizer.sanitize(SecurityContext.HTML, message ?? '')!, title ?? undefined, options)
	}

	/**
	 *
	 * @param message HTML string
	 * @param title string, don't support HTML
	 * @param timeOut time in milliseconds default 7000, 0 to keep
	 * @param positionClass position of notification default top-right
	 * @returns
	 */
	warning = (message: string, title?: string, timeOut?: number, positionClass?: positionClass): ActiveToast<any> => {
		let options = {
			... this._options,
			timeOut : timeOut ?? this._options.timeOut,
			positionClass: 'toast-' + (positionClass ?? 'top-right'),
		}
		return this.toastr.warning(this.domSanitizer.sanitize(SecurityContext.HTML, message ?? '')!, title ?? undefined, options)
	}

	/**
	 *
	 * @param message HTML string
	 * @param title string, don't support HTML
	 * @param timeOut time in milliseconds default 7000, 0 to keep
	 * @param positionClass position of notification default top-right
	 * @param shading deprecated
	 * @returns
	 */
	error = (message: string, title?: string, timeOut?: number, positionClass?: positionClass, shading?: boolean): ActiveToast<any> => {
		let options = {
			... this._options,
			timeOut : timeOut ?? this._options.timeOut,
			positionClass: 'toast-' + (positionClass ?? 'top-right')
		}
		return this.toastr.error(this.domSanitizer.sanitize(SecurityContext.HTML, message ?? '')!, title ?? undefined, options)
	}

    /**
     * Clear a specific toast by id or all toasts if no toast is provided
     * @param toast The toast to clear
     */
    clear(toast?: ActiveToast<any>) {
        this.toastr.clear(toast?.toastId);
    }
}
